import React from "react";
import { ICurrentUser } from "../types/users";

const UserContext = React.createContext({ user: {} as ICurrentUser, setUser: (user: ICurrentUser) => {} });
export const Consumer = UserContext.Consumer;

export default UserContext;
